import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CustomSideState } from './customSide.types';

import { CustomSideModel } from '~/core/models/predefined-custom-side.model';

const initialState: CustomSideState = {
  selectedCustomSide: undefined,
};

const customSideSlice = createSlice({
  name: 'customSide',
  initialState,
  reducers: {
    resetSelectedCustomSide: (state) => {
      state.selectedCustomSide = initialState.selectedCustomSide;
    },
    updateSelectedCustomSide: (
      state,
      action: PayloadAction<CustomSideModel>
    ) => {
      state.selectedCustomSide = action.payload;
    },
  },
});

export const { resetSelectedCustomSide, updateSelectedCustomSide } =
  customSideSlice.actions;

export default customSideSlice.reducer;
